<template>
  <!-- <div>icon</div> -->
  <FontAwesomeIcon
    v-if="source === 'font-awesome'"
    v-bind="$attrs"
    :icon="name"
    :size="size"
    :alt="alt"
  />
  <span
    v-else-if="source === 'custom'"
    v-bind="$attrs"
    :class="customIconClass"
    :alt="alt"
  />
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDoubleLeft,
  faExclamationCircle,
  faAngleDoubleRight,
  faCheckSquare,
  faMinusCircle,
  faImage,
  faUndoAlt,
  faRedoAlt,
  faCheckCircle,
  faChevronDown,
  faSearchPlus,
  faChevronLeft,
  faChevronRight,
  faWindowClose,
  faChevronUp,
  faQrcode,
  faCircle,
  faComment,
  faPrint,
  faCompass,
  faEllipsisH,
  faFolder,
  faFont,
  faBars,
  faHashtag,
  faHome,
  faPen,
  faPlusCircle,
  faSave,
  faSignInAlt,
  faSignOutAlt,
  faSync,
  faSyncAlt,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUserFriends
} from "@fortawesome/free-solid-svg-icons";

import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons";

library.add(
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faCheckSquare,
  faExclamationCircle,
  faCalendarAlt,
  faChevronDown,
  faSearchPlus,
  faImage,
  faUndoAlt,
  faRedoAlt,
  faChevronLeft,
  faChevronRight,
  faMinusCircle,
  faCheckCircle,
  faChevronUp,
  faCircle,
  faWindowClose,
  faBars,
  faComment,
  faPrint,
  faCompass,
  faEllipsisH,
  faFolder,
  faQrcode,
  faFont,
  faHashtag,
  faHome,
  faPen,
  faPlusCircle,
  faSave,
  faSignInAlt,
  faSignOutAlt,
  faSync,
  faSyncAlt,
  faTimesCircle,
  faTrashAlt,
  faUser,
  faUserFriends
);
export default {
  components: {
    FontAwesomeIcon
  },
  inheritAttrs: false,
  props: {
    source: {
      type: String,
      default: "font-awesome"
    },
    name: {
      type: String|Array,
      required: true
    },
    size: {
      type: String,
      required: false
    },
    alt: {
      type: String,
      required: false
    }
  },
  computed: {
    // Gets a CSS module class, e.g. iconCustomLogo
    customIconClass() {
      return this.$style[camelCase("icon-custom-" + this.name)];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/components/icon.scss";
</style>
